import React from 'react';
import { lazyRenderFeedbackPane } from 'diagnostics-and-support';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { DrawerPane, isDrawerPaneVisible } from 'owa-drawer';
import { observer } from 'owa-mobx-react';
import ProjectionContext from 'owa-popout-v2/lib/context/ProjectionContext';
import { container } from '../AppPaneGroup.scss';
import closeAppPane from '../../orchestration/closeAppPane';

const defaultExport: React.FunctionComponent = observer(function FeedbackPane() {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const targetWindow = React.useContext(ProjectionContext) as Window;
    const paneId = getDrawerPaneId('feedback');
    const isPaneVisible = isDrawerPaneVisible(paneId, targetWindow);

    const handleDismiss = React.useCallback(() => {
        closeAppPane(paneId);
    }, [paneId]);

    // The old suite flex pane used a pattern where a div was supplied, and a new React tree was rendered into it.
    // We'd like to eliminate this with our new pane by rendering content directly.
    // This will involve changes to each pane's contents.
    // Work Item: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/354471/
    React.useEffect(() => {
        if (isPaneVisible && containerRef.current) {
            lazyRenderFeedbackPane.importAndExecute(containerRef.current, handleDismiss);
        }
    }, [isPaneVisible]);

    return (
        <DrawerPane paneId={paneId} role={'complementary'}>
            <div ref={containerRef} id={paneId} className={container} />
        </DrawerPane>
    );
}, 'FeedbackPane');
export default defaultExport;
